module.exports = __webpack_public_path__ + "fonts/lato-hairline-webfont.a6f632b5.woff";